import { useState, useEffect } from 'react';
import api from '../../utils/api';

export default function AdminSiteLock() {
  const [settings, setSettings] = useState({
    locked: false,
    lockPassword: 'waveyyent2026',
  });
  const [message, setMessage] = useState('');

  useEffect(() => {
    api.get('/api/site-lock/admin')
      .then(res => setSettings(res.data))
      .catch(() => {});
  }, []);

  const handleSave = async () => {
    try {
      await api.put('/api/site-lock/admin', settings);
      setMessage('Settings saved!');
      setTimeout(() => setMessage(''), 3000);
    } catch {
      setMessage('Failed to save');
    }
  };

  return (
    <div className="max-w-2xl">
      <h2 className="text-xl font-bold mb-6">Site Lock Settings</h2>
      <div className="bg-white border border-gray-200 rounded-2xl p-6 space-y-6">
        {/* Toggle Lock */}
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-semibold text-gray-900">Lock the site</h3>
            <p className="text-sm text-gray-500">When enabled, visitors must enter the password to access the store.</p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={settings.locked}
              onChange={e => setSettings({...settings, locked: e.target.checked})}
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:bg-black after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full"></div>
          </label>
        </div>

        {/* Password */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Site Password</label>
          <input
            type="text"
            className="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-black"
            placeholder="Enter a password"
            value={settings.lockPassword}
            onChange={e => setSettings({...settings, lockPassword: e.target.value})}
          />
        </div>

        <button
          onClick={handleSave}
          className="w-full bg-black text-white py-3 font-semibold rounded-xl hover:bg-gray-900 transition"
        >
          Save Settings
        </button>

        {message && <p className="text-center text-sm text-green-600">{message}</p>}
      </div>
    </div>
  );
}